import { useDispatch, useSelector } from 'react-redux'
import { toggleMusic } from '@slices/uiSlice'
import { soundManager } from '@core/audio/sounds/soundManager'
import { MusicOffSVG, MusicOnSVG } from '@media/svgs'

const AudioControlsModule = () => {
  const dispatch = useDispatch()
  const isMusicEnabled = useSelector((state) => state.ui.audio.music.enabled)
  const handleToggleMusic = () => {
    soundManager.play('CLICK')
    dispatch(toggleMusic())
  }

  return (
    <div className="standard-normal-audio-controls-module-container">
      <button
        type="button"
        className="standard-normal-audio-controls-icon-container"
        onClick={handleToggleMusic}
        aria-label="Toggle music"
      >
        {isMusicEnabled ? (
          <MusicOnSVG width={25} height={25} />
        ) : (
          <MusicOffSVG width={25} height={25} />
        )}
      </button>
    </div>
  )
}

export default AudioControlsModule
